<template>
    <div class="form-table form-table--sow form-table--without-scroll">
        <div class="form-table__header j-c--s-b">
            SOW
            <span v-if="!is_create" @click="onAdd">Add SOW</span>
        </div>
        <div class="table-wrap">
            <table class="table">
                <thead>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Valid to</th>
                    <th>Action</th>
                </thead>
                <tbody>
                    <tr v-if="items.length <= 0">
                        <td colspan="4" class="center">No data</td>
                    </tr>
                    <tr v-else v-for="item in items">
                        <td>
                            <span class="link" @click="onEdit(item.id)">{{
                                item.name
                            }}</span>
                        </td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.valid_date ? item.valid_date : "-" }}</td>
                        <td>
                            <a
                                :href="item.file_url || item.url"
                                style="display: block; margin-bottom: 2px"
                                type="button"
                            >
                                {{ item.url ? "Open link" : "View file" }}
                            </a>
                            <a
                                href="#"
                                style="display: block; margin-bottom: 2px"
                                @click.prevent="deleteSOW(item.id)"
                                type="button"
                            >
                                Remove
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <deal-sow-modal
            v-if="isAdd || editId"
            :editId="editId"
            :editData="editData"
            :deal_id="deal_id"
            :onAdd="addSOWFile"
            :onEdit="updateSOWFile"
            :onClose="handleClose"
            :generated_title="`${brand_name}-${currentDate}-SOW ${
                items.length + 1
            }`"
            :check_sow="check_sow"
        ></deal-sow-modal>
    </div>
</template>

<script>
import moment from "moment";
import DealSOWModal from "./AddSOW.vue";

export default {
    name: "Deal_SOW_Table",
    props: {
        deal_id: {
            type: Number,
        },
        brand_name: {
            type: String,
        },
        is_create: {
            type: Boolean,
            default: false,
        },
        check_sow: {
            type: Boolean,
        },
    },
    components: {
        "deal-sow-modal": DealSOWModal,
    },
    created() {
        this.$root.$refs.Deal_SOW_Table = this;
    },
    data() {
        return {
            isAdd: false,
            items: [],
            editId: null,
        };
    },
    computed: {
        editData() {
            return this.items.find((item) => item.id === this.editId);
        },
        currentDate() {
            return moment().format("MM.DD.YY");
        },
    },
    mounted() {
        console.log("GGGGG", this.check_sow);

        if (this.deal_id) {
            this.getSOWList();

            this.onCheckActionParam();
        }
    },
    methods: {
        onAdd() {
            this.isAdd = true;
        },
        onEdit(id) {
            this.editId = id;
        },
        handleClose() {
            this.isAdd = false;
            this.editId = null;
        },
        deleteSOW(id) {
            axios
                .post("/deals/sow/remove", {
                    id: id,
                })
                .then(() => {
                    this.getSOWList();
                    this.$root.$refs.Deal_Services_Table.getSOWList();
                })
                .catch((err) => {
                    console.log("ERROR deleteSOW", err);
                });
        },
        addSOWFile(data) {
            axios
                .post("/deals/sow/add", data, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(() => {
                    this.getSOWList();

                    this.handleClose();
                    this.$root.$refs.Deal_Services_Table.getSOWList();
                })
                .catch((err) => {
                    console.log("ERROR addSOWFile", err);
                });
        },

        updateSOWFile(data) {
            axios
                .post("/deals/sow/update", data, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(() => {
                    this.getSOWList();
                    this.handleClose();
                    this.$root.$refs.Deal_Services_Table.getSOWList();
                })
                .catch((err) => {
                    console.log("ERROR addSOWFile", err);
                });
        },

        getSOWList() {
            axios
                .post("/deals/sow/getList", {
                    deal_id: this.deal_id,
                })
                .then((response) => {
                    if (response.data.isSuccess) {
                        this.items = response.data.items;
                    }
                })
                .catch((err) => {
                    console.log("ERROR getSOWList", err);
                });
        },

        onCheckActionParam() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const action = urlParams.get("action");
            if (action === "add_new_sow") {
                this.isAdd = true;
            }
        },
    },
};
</script>
